export default __webpack_public_path__ + "static/apple.url-82c653b530b0aa1f8b6fc1fd2d311f3c.svg";